import { AssistantBridgeControlPlaneSection } from './AssistantBridgeControlPlaneSection';
import { PaymentsControlPlaneSection } from './PaymentsControlPlaneSection';

export const IntegrationsSection = () => (
  <div className="space-y-6">
    <PaymentsControlPlaneSection mode="summary" />
    <AssistantBridgeControlPlaneSection mode="safe" />
  </div>
);
